export const projectsData = {
  commercial: [
    '/images/projects/WR-Ansley-3.jpg',
    '/images/projects/WR-Ansley-2.jpg',
    '/images/projects/WR-Toyota-1-1.jpg',
    '/images/projects/WR-Ansley-1.jpg',
    '/images/projects/WR-FarmviewFrontal_Edit-Extended_Web.jpg'
  ],
  federalProjects: [
    '/images/projects/FG-Summit-1.jpg',
    '/images/projects/FG-MLK-1.jpg',
    '/images/projects/FG-Summit-2.jpg',
    '/images/projects/FG-Summit-4.jpg',
    '/images/projects/FG-MLK-3.jpg',
    '/images/projects/FG-MLK-2.jpg',
  ],
  generators: [
    '/images/projects/G-LogistiCare-3.jpg',
    '/images/projects/G-Alpa-2.jpg',
    '/images/projects/G-Alpa-1.jpg',
    '/images/projects/G-LogistiCare-5.jpg',
    '/images/projects/G-Alpa-3.jpg',
    '/images/projects/G-LogistiCare-4.jpg',
  ],
  historicalRenovations: [
    '/images/projects/HR-Cherry-St-1.jpg',
    '/images/projects/HR-Cherry-St-2.jpg',
    '/images/projects/HR-Cherry-St-3.jpg',
    '/images/projects/HR-Cherry-St-4.jpg',
    '/images/projects/HR-Cherry-St-5.jpg',
    '/images/projects/HR-Cherry-St-6.jpg',
  ],
  newConstruction: [
    '/images/projects/NC-NIBCO-END16.jpg',
    '/images/projects/NC-NIBCO-END23.jpg',
    '/images/projects/NC-NIBCO-END15.jpg',
    '/images/projects/NC-NIBCO-Sign.jpg',
    '/images/projects/NC-NIBCO-END32.jpg',
    '/images/projects/NC-NIBCO-Begin.jpg',
    '/images/projects/NC-NIBCO-END29.jpg',
  ],
  restaurants: [
    '/images/projects/R-BK-ThomasCrossroads-2.jpg',
    '/images/projects/R-BK-ThomasCrossroads-1.jpg',
    '/images/projects/R-BK-ThomasCrossroads-3.jpg',
    '/images/projects/R-Starbucks-PowersFerry-1.jpg',
  ],
  warehouses: [
    '/images/projects/WR-JFC04.jpg',
    '/images/projects/WR-JFC03.jpg',
    '/images/projects/WR-5395-Oakley-5.jpg',
    '/images/projects/WR-JFC09.jpg',
    '/images/projects/WR-JFC05.jpg',
    '/images/projects/WR-5395-Oakley-2.jpg',
    '/images/projects/WR-JFC08.jpg',
    '/images/projects/WR-5395-Oakley-6-1.jpg',
    '/images/projects/WR-JFC02.jpg',
  ],
};
